import { ICourierRequest } from '~interfaces/ICourierInterfaces';
import { ErrorHandler } from './ErrorHandler';
import { courierQuoteApi } from '~constants/constants';

export type ICourierResponse = {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    result: any;
};

export class CourierApi {
    //@ts-ignore
    private readonly courierUrl: string;
    private errorHandler: ErrorHandler;

    constructor(siteUrl: string) {
        this.courierUrl = courierQuoteApi;
        this.errorHandler = new ErrorHandler();
    }

    private fetchJson = async (reqBody: ICourierRequest) => {
        const bodyParams = this.getReqBody(reqBody);
        try {
            const res = await fetch(this.courierUrl, {
                method: 'POST',
                body: `JSONRPC=${encodeURIComponent(bodyParams)}`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            const json = await res.json();

            return json;
        } catch (err) {
            throw err;
        }
    };

    private getReqBody(reqParams: ICourierRequest) {
        return JSON.stringify([
            {
                method: 'courier.get_quote',
                params: [reqParams]
            }
        ]);
    }

    public getCourierQuote = async <T extends ICourierRequest>(
        request: T
    ): Promise<ICourierResponse[]> => this.errorHandler.tryRequest(() => this.fetchJson(request));
}
